import { inject, Pipe, PipeTransform } from '@angular/core';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';

/** Bypass sanitizer for developer-controlled SVG/HTML constants (e.g. icon strings). */
@Pipe({ name: 'safeHtml', standalone: true })
export class SafeHtmlPipe implements PipeTransform {
  private readonly san = inject(DomSanitizer);

  transform(html: string | null | undefined): SafeHtml {
    return this.san.bypassSecurityTrustHtml(html ?? '');
  }
}
